// extracted by mini-css-extract-plugin
export var container = "_82-0";
export var icon = "_82-1";
export var text = "_82-2";